import styled from "styled-components";
export const Container = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  overflow: hidden;
`;
export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InnerTopContainer = styled.div``;

export const Heading = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 575px) {
    font-size: 38px;
  }
`;
export const Description = styled.p`
  font-size: 32px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
  @media (max-width: 575px) {
    font-size: 14px;
  }
`;

export const BottomContainer = styled.div`
  /* display: flex;
  flex-direction: row; */
  padding-top: 50px;
  padding-left: 216px;
  padding-right: 216px;
  @media (max-width: 575px) {
    padding: unset;
  }
`;
export const InnerBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 130px;
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

export const Icon = styled.img`
  height: 60px;
  width: 60px;
`;
export const Title = styled.h3`
  text-align: center;
  font-size: 24px;
  font-family: Poppins-Medium;
  color: #03213b;
  margin-bottom: unset;
`;
export const IconDescription = styled.p`
  text-align: center;
  font-size: 14px !important;
  font-family: Poppins-Light;
  color: #03213b;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const Circle = styled.div`
  height: 150px;
  width: 150px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 4px 5px 6px #00000029;
  display: flex;
  align-items: center;
  justify-content: center;
`;
